export interface BatchSchoolStatisticsPageLoadRequest {
  batchType: string
}

export function BatchSchoolStatisticsPageLoadRequestToJSON(
  value: BatchSchoolStatisticsPageLoadRequest
): any {
  return {
    batch_type: value.batchType
  }
}
